import React from 'react';

const PartnersPage = React.lazy(() => import('pages/partners'));
const PartnersEditPage = React.lazy(() => import('pages/partners/edit'));
const SubmitNewPartnerPage = React.lazy(() => import('pages/partners/edit'));

const policies = [{ resource: 'trends', action: 'view' }];

export const definitions = [
  {
    index: true,
    policies: policies,
    component: <PartnersPage />
  },
  {
    path: 'edit/:partnerID',
    policies: policies,
    component: <PartnersEditPage />
  },
  {
    path: 'new',
    policies: policies,
    component: <SubmitNewPartnerPage />
  }
];
